import React, { useState, useEffect } from "react";
import SlideBar from "../../component/sidebar/sidebar";
import DashboardHeader from "../../component/dashboard-header";
import editoutline from "../../assets/images/edit-outline.svg";
import listView from "../../assets/svg/scheduling/listViewIcon.svg";
import currentDatas from "../../dummyjson/channelList.json";
import "./scheduling.scss";
import rightarrow from "../../assets/images/rightvector.png";
import leftarrow from "../../assets/images/Vector.png";
import scheduleActive from "../../assets/svg/scheduling/Complted.svg";
import scheduleHalf from "../../assets/svg/scheduling/Inprogress.svg";
import icroundsearchGray from "../../assets/images/ic_round-search-gray.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import { cloudFront_URL } from "../../service/API_URL";
import uploadicon from "../../assets/images/uploadicon.png";
import downloadicon from "../../assets/svg/scheduling/download.svg";
import refresh from "../../assets/images/refresh.png";
import { toast, ToastContainer } from "react-toastify";
import { permissionDetails } from "../../utility/localStoageData";
import image_thum from "../../assets/images/image-thum.png";
import Loader from "../../component/Loader/Loader";
import { CsvErrorPopUp } from "./CsvErrorPopUp";
import { ScheduleUpload_URL } from "../../service/API_URL";

import { postFormData } from "../../api/apiMethod";

import { GetScheduleList, ListApiSync, ExportSchedule } from "../../api/api";

import CalendarComponent from "./Schedule";
function Scheduling() {
    // const pageSize = 5; // Number of items per page
    const [searchParams, setSearchParams] = useSearchParams();
    const [currentPage, setCurrentPage] = useState(Number(searchParams.get("page")) || 0);
    const [scheduleList, setScheduleList] = useState([]);
    const [daysList, setDaysList] = useState('7');
    const [startDay, setStartDay] = useState("");
    const [endDay, setEndDay] = useState("");
    const [uploadID, setUploadID] = useState("");
    const [channelAssemblyType, setChannelAssembly] = useState("");
    const navigate = useNavigate();
    const [permission, setpermission] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [sortColumn, setSortColumn] = useState("name");
    const [sortDirection, setSortDirection] = useState("asc");
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [pageJump, setPageJump] = useState(0);
    const [showLoader, setShowLoader] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [csvErrorData, setCsvErrorData] = useState([]);
    const [tenantCode, setTenantCode] = useState("");
    const startIndex = currentPage * pageSize;
    const endIndex = startIndex + pageSize;
    const currentData = currentDatas.slice(startIndex, endIndex);

    const handlePrevPage = () => {
        if (currentPage > 0) {
            // setCurrentPage(currentPage - 1);
            fetchSchedule(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages - 1) {
            // setCurrentPage(currentPage + 1);
            fetchSchedule(currentPage + 1);
        }
    };

    const uploadFile = async (event) => {
        const selectedFile = event.target.files[0];

        if (selectedFile) {
            const formData = new FormData();
            formData.append("file", selectedFile);
            try {
                let URL = "";
                if (channelAssemblyType === "RUNN_MEDIA") {
                    URL = `${ScheduleUpload_URL}/${uploadID}/schedule/internal/csv`;
                } else {
                    URL = `${ScheduleUpload_URL}/${uploadID}/schedule/external/csv`;
                }
                const response = await postFormData(URL, formData);
                
                if (response?.data?.status) {
                    toast.success("File uploaded successfully", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        autoClose: 5000,
                    });
                    fetchSchedule(currentPage);
                } else {
                    if (response?.data?.data != null) {
                        setShowPopup(true);
                        setCsvErrorData({...response?.data, fileName: selectedFile?.name});
                    }
                    toast.error(response?.data?.message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        autoClose: 10000,
                    });
                }
            } catch (error) {
                toast.error(error.response.data.message, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    autoClose: 10000,
                });
            }
        }
        event.target.value = "";
    };

    useEffect(() => {
        getPermission();
        fetchSchedule(currentPage);
        setTenantCode(JSON.parse(localStorage.getItem("tenantInfo")).code);
    }, [daysList]);

    const fetchSchedule = async (currentPage) => {
        setShowLoader(true);
        let queryParams = {
            searchText: searchText,
            sortBy: sortColumn,
            sortOrder: sortDirection,
            pageNumber: currentPage,
            pageSize: pageSize,
            daysList: daysList,
        };
        let scheduleData = await GetScheduleList(queryParams);
        setScheduleList(scheduleData?.data);
        setShowLoader(false);
        const pageNumber = scheduleData?.data?.number || 0;
        setCurrentPage(pageNumber);
        setSearchParams({ page: pageNumber });
        setTotalPages(scheduleData?.data?.totalPages);
        scheduleData = scheduleData?.data?.content;
        const startDate =
            scheduleData[0].commonScheduleChannelDetails[0].scheduleDate.split("-");
        setStartDay(startDate[2] + "-" + startDate[1] + "-" + startDate[0]);
        const len = scheduleData[0].commonScheduleChannelDetails.length;
        const endDate =
            scheduleData[0].commonScheduleChannelDetails[len - 1].scheduleDate.split(
                "-"
            );
        setEndDay(endDate[2] + "-" + endDate[1] + "-" + endDate[0]);
        // totalPages = Math.ceil(scheduleData.length / pageSize);
    };

    const redirectScheduleDetail = (
        channelId,
        channelName,
        type,
        scheduleType,
        defaultFiller,
        channelAssembly,
        scheduleReset,
        categories,
    ) => {
        const redirectPage =
            scheduleType === "LOOP" ? "/schedule-Loop" : "/scheduling-linear";
        // const redirectPage = (scheduleType === 'LOOP') ? '/schedule-Loop' : '/schedulingDetail';
        navigate(redirectPage, {
            state: {
                channelId,
                channelName,
                type,
                defaultFiller,
                permission: permission,
                channelAssembly,
                scheduleReset,
                categories,
            },
        });
    };

    const listUpdate = async (id, name, type, scheduleType, defaultFiller, channelAssembly, scheduleReset, categories) => {
        if (type === "XLSInput" || channelAssembly === "RUNN_MEDIA") {
            setUploadID(id);
            setChannelAssembly(channelAssembly);
            document.getElementById("fileid").click();
        } else if (type === "APIDriven") {
            const response = await ListApiSync(id);

            if (response) {
                toast.success("Channel Sync successfully", {
                    position: toast.POSITION.BOTTOM_LEFT,
                    autoClose: 3000,
                });
            } else {
                toast.error("Channel Sync failed", {
                    position: toast.POSITION.BOTTOM_LEFT,
                    autoClose: 3000,
                });
            }
        } else {
            redirectScheduleDetail(id, name, type, scheduleType, defaultFiller, channelAssembly, scheduleReset, categories);
        }
    };

    const getDate = (date) => {
        const current = new Date(date);
        const today = current.toLocaleDateString("en-US", { weekday: "long" });
        return today.substring(0, 3);
    };

    const getStatus = (status, returnImage) => {
        if (status === "Complete") {
            return returnImage ? scheduleActive : "scheduleActive";
        } else if (status === "In Progress") {
            return returnImage ? scheduleHalf : "scheduleHalfActive";
        } else {
            return returnImage ? "" : "scheduleInActive";
        }
    };

    const getPermission = () => {
        let findEdit = permissionDetails();
        if (findEdit.includes("SCHEDULING_EDIT")) setpermission("edit");
        else if (findEdit.includes("SCHEDULING_READ")) setpermission("read");
        else setpermission(null);
    };

    const setPage = (e) => {
        if (e.target.value > 0 && e.target.value <= totalPages) {
            setPageJump(e.target.value - 1);
        }
    };
    const setPageBySelect = (e) => {
        if (e > 0 && e <= totalPages) {
            setPageJump(e - 1);
            fetchSchedule(e - 1)
        }
    };
    const setPageByButton = (e) => {
        if (e > 0 && e <= totalPages) {
            setPageJump(e - 1);
            fetchSchedule(e - 1)
        }
    };

    const setSearch = (e) => {
        setSearchText(e.target.value);
        if (e.target.value === "" || e.target.value.length >= 3) {
            fetchSchedule();
        }
    };

    const handleKeyPress = (event) => {
        event.preventDefault();
        fetchSchedule(pageJump);
    };

    const handleSearch = (event) => {
        event.preventDefault();
        fetchSchedule();
    };

    const generatePageNumbers = (currentPage, totalPages) => {
        const pages = [];

        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
            }
        } else {
            pages.push(1); // Always show first page

            if (currentPage > 3) {
            pages.push("..."); // Left ellipsis
            }

            const startPage = Math.max(2, currentPage - 1);
            const endPage = Math.min(totalPages - 1, currentPage + 1);

            for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
            }

            if (currentPage < totalPages - 2) {
            pages.push("..."); // Right ellipsis
            }

            pages.push(totalPages); // Always show last page
        }

        return pages;
    };
    const pageNumbers = generatePageNumbers(currentPage + 1, totalPages);

    const closePopup = () => {
        setShowPopup(false);
    };

    const downloadCSVFunc = async (channelId, channelName) => {
        const res = await ExportSchedule(channelId, daysList, channelName);       
    }

    return permission !== null ? (
        <div className="content-body Scheduling" style={{ padding: "20px", background: "#262626" }}>
            <div className="dashboard-content">
                <div className="top-content align-items-start">

                    <div className="left-side">
                        <h3>Scheduling</h3>
                    </div>

                    <div className={`channel-form ${daysList == 15 ? "w-1200" : ""}`} style={{ width: '600px' }}>
                        <form className="d-flex justify-content-end" onSubmit={handleSearch}>
                            <div className="form-group">
                                <input
                                    type="text"
                                    placeholder="Search by channel name"
                                    value={searchText}
                                    onChange={setSearch}
                                />
                                <button type="submit">
                                    <img src={icroundsearchGray} alt="" />
                                </button>
                            </div>
                        </form>
                    </div>





                    {/* <div className="left-side">
            <h3 style={{ fontSize: 32 }}>Scheduling</h3>
          </div> */}
                </div>
                {/* <div className={`channel-form ${daysList == 15 ? "w-1200" : ""}`}>
          <form onSubmit={handleSearch}>
            <div className="form-group">
              <input
                type="text"
                placeholder="Search by channel name"
                value={searchText}
                onChange={setSearch}
              />
              <button type="submit">
                <img src={icroundsearchGray} alt="" />
              </button>
            </div>
          </form>
        </div> */}

                <div
                    className={`table table-striped scheduling-main-table mb-0 ${daysList == 15 ? "w-1400" : "w-1800"
                        }`}
                >
                    {showLoader ? (
                        <div className="tableLoader">
                            <Loader></Loader>
                        </div>
                    ) : (
                        <table>
                            <thead>
                                <tr>
                                    <th width="10%">Channel LOGO</th>
                                    <th className="text-center" width="20%">Channel Name</th>
                                    <th
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            width: "100%",
                                        }}
                                    >
                                        <div>
                                            <span style={{ fontSize: "14px" }}>Date : </span>
                                            {/* <b> */}
                                                <span style={{ backgroundColor: '#FFFFFF1F', padding: '6px', color: '#fff', borderRadius: "6px", fontWeight: "500" }}>
                                                    {startDay}
                                                </span>
                                                <span style={{ fontSize: "14px" }}>
                                                    {" to "}
                                                </span>
                                                <span style={{ backgroundColor: '#FFFFFF1F', padding: '6px', color: '#fff', borderRadius: "6px", fontWeight: "500" }}>
                                                    {endDay}
                                                </span>
                                            {/* </b> */}
                                        </div>
                                        <div className="text-right d-flex"
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "flex-end",
                                                // gap: "10px",
                                                minWidth: "250px",
                                            }}>
                                            <span >Status for</span>
                                            <select
                                                className="select-grid-header"
                                                value={daysList} // Bind value to the state
                                                onChange={(e) => setDaysList(e.target.value)} // Update state on change
                                                style={{
                                                    padding: "5px",
                                                    fontSize: "12px",
                                                    // backgroundColor: "#606264",
                                                    backgroundColor: "#FFFFFF14",
                                                    color: "#fff",
                                                    width: "7.375rem",
                                                    border: "none"
                                                }}
                                            >
                                                <option value="7" style={{
                                    background: "#3F3E3E",
                                    color: "#fff",
                                }}>Next 7 days</option>
                                                <option value="15" style={{
                                    background: "#3F3E3E",
                                    color: "#fff",
                                }}>Next 15 days</option>
                                            </select>
                                        </div>
                                    </th>
                                    <th width="15%">ACTION</th>
                                </tr>
                            </thead>
                            <tbody >
                                {scheduleList?.content.length !== 0 ? (
                                    scheduleList?.content?.map((item, index) => (
                                        <tr
                                            key={index}
                                            onClick={() =>
                                                redirectScheduleDetail(
                                                    item.channelId,
                                                    item.channelName,
                                                    item.epgType,
                                                    item?.scheduleType,
                                                    item?.filler,
                                                    item?.channelAssembly,
                                                    item?.scheduleReset,
                                                    item?.categories,
                                                )
                                            }
                                        >
                                            <td>



                                                <div
                                                    key={index}
                                                    style={{
                                                        // backgroundColor: index % 2 === 0 ? '#F12D34' : '#000',
                                                        backgroundColor: "#262626",
                                                        width: 120,
                                                        height: 70,
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        borderRadius: 6
                                                    }}
                                                >
                                                    <img
                                                        src={
                                                            item?.channelLogo[0]?.thumbnailSourcePath
                                                                ? cloudFront_URL + item?.channelLogo[0]?.thumbnailSourcePath
                                                                : image_thum
                                                        }
                                                        className="img-40 mx-auto w-50 h-50"
                                                        alt=""
                                                    />
                                                </div>


                                            </td>
                                            <td className="text-center">{item.channelName}</td>
                                            {item.scheduleType === "LOOP" ? (
                                                <td className="text-center">
                                                    {/* <div className="d-flex justify-content-between align-items-center" >
                          
                            <span class="list-view-btn fs-6 w-100 border py-1 rounded" style={{backgroundColor:'#FAEAE914'}}>
                            <a className="edit-icon list-view-icon ">
                              <img src={listView} alt="" style={{paddingRight:20}} />
                            </a>
                              List View
                            </span>
                          </div> */}
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span
                                                            className="list-view-btn fs-6 w-100 py-1 rounded m-0"
                                                            style={{
                                                                backgroundColor: '#333333',
                                                                height: "2.75rem"
                                                            }}
                                                        >
                                                            <a className="edit-icon list-view-icon">
                                                                <img src={listView} alt="" style={{ paddingRight: 20 }} />
                                                            </a>
                                                            List View
                                                        </span>
                                                    </div>

                                                </td>
                                            ) : (
                                                <td>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            // gap: "10px",
                                                            gap: "1%",
                                                            // padding: "10px",
                                                        }}
                                                    >
                                                        {item.commonScheduleChannelDetails.map((schedule, index) => (
                                                            <div
                                                                key={index}
                                                                style={{
                                                                    // flex: 1,
                                                                    // padding: "10px",
                                                                    padding: `${daysList == 15? "1% 0px": "1% 0px"}`,
                                                                    backgroundColor:
                                                                        schedule.scheduleStatus === "Complete"
                                                                            ? "#73DF5C"
                                                                            : schedule.scheduleStatus === "In Progress"
                                                                                ? "#FABD40"
                                                                                : "#C5E7F7",
                                                                    borderRadius: "4px",
                                                                    color: "#000",
                                                                    textAlign: "center",
                                                                    position: "relative",
                                                                    // height: `${daysList == 15? "24px": "30px"}`,
                                                                    width: `${daysList == 15? "7%" : "12%"}`,
                                                                    fontSize: `${daysList == 15? "12px":"14px"}`
                                                                }}
                                                            >
                                                                <span>{getDate(schedule.scheduleDate)}</span>
                                                                {schedule?.scheduleStatus !== 'Empty' &&
                                                                    <div
                                                                        style={{
                                                                            position: "absolute",
                                                                            right: "-10px",
                                                                            bottom: "-10px",
                                                                            // backgroundColor: "#fff", 
                                                                            borderRadius: "50%",
                                                                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                                                            padding: "2px",
                                                                            width: "24px",
                                                                            height: "24px",
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                        }}
                                                                    >

                                                                        <img
                                                                            src={getStatus(schedule.scheduleStatus, true)}
                                                                            alt="Status Icon"
                                                                            style={{

                                                                                width: "18px",
                                                                                height: "18px",
                                                                            }}
                                                                        />
                                                                    </div>}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>




                                            )}

                                            {permission === "edit" ? (
                                                <td> 
                                                    <>
                                                        {
                                                            item?.channelAssembly === "RUNN_MEDIA"?
                                                            <>
                                                                {
                                                                    tenantCode === "runn" || tenantCode === "nhstdz" ?
                                                                    <a
                                                                        className="edit-icon me-2"
                                                                        onClick={(event) => {
                                                                            event.stopPropagation();
                                                                            downloadCSVFunc(item.channelId, item.channelName);
                                                                        }}
                                                                        style={{
                                                                            background: "#404040",
                                                                            padding: "6px 3px",
                                                                            borderRadius: "4px"
                                                                        }}
                                                                    >
                                                                        <img src={downloadicon} style={{filter: "invert(0.30)"}} alt="" />
                                                                    </a>
                                                                    :
                                                                    ''
                                                                }
                                                                <a
                                                                    className="edit-icon me-2"
                                                                    onClick={(event) => {
                                                                        event.stopPropagation();
                                                                        listUpdate(
                                                                            item.channelId,
                                                                            item.channelName,
                                                                            item.epgType,
                                                                            item.scheduleType,
                                                                            item?.filler,
                                                                            item?.channelAssembly,
                                                                            item?.scheduleReset,
                                                                            item?.categories,
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        background: "#404040",
                                                                        padding: "6px 3px",
                                                                        borderRadius: "4px"
                                                                    }}
                                                                >
                                                                    <img src={uploadicon} alt="" />
                                                                </a>
                                                            </>
                                                            :
                                                            ''
                                                        }
                                                        <a
                                                            className="edit-icon"
                                                            onClick={(event) => {
                                                                event.stopPropagation();
                                                                listUpdate(
                                                                    item.channelId,
                                                                    item.channelName,
                                                                    item.epgType,
                                                                    item.scheduleType,
                                                                    item?.filler,
                                                                    item.epgType === "XLSInput" || item.epgType === "APIDriven"
                                                                    ? item?.channelAssembly
                                                                    : "",
                                                                    item?.scheduleReset,
                                                                    item?.categories,
                                                                );
                                                            }}
                                                            style={{
                                                                background: "#404040",
                                                                padding: "6px 3px",
                                                                borderRadius: "4px"
                                                            }}
                                                        >
                                                            {item.epgType === "XLSInput" ? (
                                                                <img src={uploadicon} alt="" />
                                                            ) : item.epgType === "APIDriven" ? (
                                                                <img src={refresh} alt="" />
                                                            ) : (
                                                                <img src={editoutline} alt="" />
                                                            )}
                                                        </a>
                                                    </>
                                                </td>
                                            ) : (
                                                ""
                                            )}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td className="text-center" colspan="5">
                                            No data Found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}
                </div>

                <div className={`table-pagination mt-2 rounded row justify-content-between m-0 border-0 ${daysList == 15 ? "w-1200" : ""}`}>
                    <div className="page-no-container col-3">
                        <div className="count py-1">
                            Page No. 
                            &nbsp;
                            <select
                                className="rounded select-grid-header"
                                style={{
                                    padding: "6px 10",
                                    fontSize: "12px",
                                    // backgroundColor: "#606264",
                                    backgroundColor: "#FFFFFF14",
                                    color: "#fff",
                                    border: "none",
                                    minWidth: "3.125rem"
                                }}
                                value={currentPage + 1}
                                onChange={(e) => setPageBySelect(Number(e.target.value))}
                            >
                            {Array.from({ length: totalPages }, (_, i) => (
                                <option 
                                style={{
                                    background: "#3F3E3E",
                                    color: "#fff",
                                }}
                                 key={i + 1} value={i + 1}>
                                {i + 1}
                                </option>
                            ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-3 d-flex justify-content-center py-1">
                        <div className="text-center mx-1 py-1">
                            Page: {currentPage + 1} of {totalPages}&nbsp; |
                        </div>
                        <div className="text-center mx-1 py-1">
                            {startIndex + 1}-{Math.min(endIndex, scheduleList.totalElements)}{" "}
                            of {scheduleList.totalElements}
                        </div>
                    </div>
                    <div className="pagination-numbers col-5 text-end">
                        <div className="pagination-arrow">
                            <a onClick={handlePrevPage} className="prev rounded"
                                style={{
                                    background: `${currentPage > 0 ? "#444649" : "#323233"}`,
                                    padding: "12px 18px",
                                }}
                            >
                                {" "}
                                <img src={leftarrow} alt="leftarrow" />
                            </a>
                            {/* <div className="text-center">
                                <form onSubmit={handleKeyPress}>
                                    <input
                                        type="text"
                                        defaultValue={currentPage + 1}
                                        onChange={setPage}
                                    />
                                </form>
                            </div> */}
                            {pageNumbers.map((page, index) => (
                                <button
                                key={index}
                                disabled={page === "..."}
                                onClick={() => {
                                    if (page !== "...") {
                                        setCurrentPage(page - 1);
                                        setSearchParams({ page: page - 1 });
                                        setPageByButton(page);
                                    }
                                }}
                                style={{
                                    padding: "8px 15px",
                                    margin: "0 4px",
                                    backgroundColor: page === currentPage + 1 ? "#2E3033" : "transparent",
                                    color: page === currentPage + 1 ? "#A3A3A3" : "#A3A3A3",
                                    border: page === currentPage + 1 ? "1px solid #606264" : "none",
                                    borderRadius: "5px",
                                    cursor: page === "..." ? "default" : "pointer",
                                }}
                                >
                                {page}
                                </button>
                            ))}
                            <a onClick={handleNextPage} className="next rounded"
                                style={{
                                    background: `${currentPage < totalPages - 1 ? "#444649" : "#323233"}`,
                                    padding: "12px 18px",
                                }}
                            >
                                {" "}
                                <img src={rightarrow} alt="rightarrow" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
            <input
                id="fileid"
                type="file"
                hidden
                onChange={(event) => uploadFile(event)}
            />
            {
                showPopup &&
                <CsvErrorPopUp show={showPopup} csvErrorData={csvErrorData} handleClose={closePopup}/>
            }
            {/* <CalendarComponent /> */}
        </div>
    ) : (
        ""
    );
}

export default Scheduling;
